import {
  Box,
  Divider,
  List,
  ListItem,
  Tooltip,
  Typography,
  AppBar,
  Tab,
  Tabs,
  withStyles,
  makeStyles
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import 'leaflet-rotatedmarker';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { INFOR_CAR, INFOR_MOTO } from 'src/app/constant/config';

const BASIC_FIELDS = [
  'device_id',
  'device_type',
  'device_status',
  'license_plate',
  'lat',
  'lng',
  'vehicle_type',
  'created_at'
];

const FIXED_FIELDS = [
  'license_plate',
  'serial',
  'device_type',
  'sim',
  'active_at'
];

const CALCULATED_FIELDS = ['remaining_days'];

const LocationDisplay = ({ address }) => {
  const maxLength = 25;
  const truncatedAddress =
    address && address.length > maxLength
      ? `${address.substring(0, maxLength)}...`
      : address
      ? address
      : '--';

  return (
    <Tooltip title={address || ''} arrow>
      <div style={{ fontSize: '12px', float: 'right', textAlign: 'right' }}>
        {truncatedAddress}
      </div>
    </Tooltip>
  );
};

const Level4GlAndsatellitesDisplay = ({ level_4g, gsm_signal }) => {
  return (
    <Typography>
      <div style={{ fontSize: '12px' }}>
        {/* {level_4g || '--'} - {gsm_signal || '--'} */}
        {gsm_signal || '--'}
      </div>
    </Typography>
  );
};

const DisplayGsmColumn = ({detailedInfo}) => {
  const level = detailedInfo?.gsm_level || 0;
  return (
    <img
      src={`/static/iconSvg/gsm/${level}_column.svg`}
      style={{
        paddingRight: '5px',
        marginLeft: '0 !important'
      }}
    />
  );
};

const TabPanel = props => {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ height: '380px' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const CustomTab = withStyles({
  root: {
    backgroundColor: '#F6F6F6',
    color: '#475461',
    fontSize: '14px',
    width: '105px'
  },
  selected: {
    backgroundColor: '#ffffff',
    color: '#D9042F',
    fontWeight: 600,
    fontSize: '14px'
  }
})(Tab);

const ContentCarInfo = ({
  positionsInfoBox,
  detailedVehicleInfo,
  isLoadingDetail
}) => {
  const isMotorGPS =
    positionsInfoBox?.device_type === 'VGPS_MOTO4G' ? true : false;
  const vehicleInfoBox = isMotorGPS ? INFOR_MOTO : INFOR_CAR;
  const [value, setValue] = React.useState(0);
  const [isInitialLoading, setIsInitialLoading] = useState(false);
  const [hasShownInitialLoading, setHasShownInitialLoading] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (positionsInfoBox?.device_id && !hasShownInitialLoading) {
      setIsInitialLoading(true);
      setHasShownInitialLoading(true);
    }
  }, [positionsInfoBox?.device_id, hasShownInitialLoading]);

  useEffect(() => {
    if (!isLoadingDetail && isInitialLoading) {
      setIsInitialLoading(false);
    }
  }, [isLoadingDetail, isInitialLoading]);

  const getRemainingDays = endDate => {
    if (!endDate) {
      return '--';
    }
    try {
      const now = moment();
      const expiration = moment(endDate);
      if (!expiration.isValid()) {
        return '--';
      }
      if (expiration.isBefore(now)) {
        return 'Hết hạn';
      }
      const duration = moment.duration(expiration.diff(now));
      const days = Math.floor(duration.asDays());
      if (days >= 1) {
        return `${days} Ngày`;
      }
      const hours = Math.floor(duration.asHours());
      if (hours >= 1) {
        return `${hours} Giờ`;
      }
      const hoursRemaining = Math.floor(duration.asHours());
      const minutes = Math.floor(duration.asMinutes()) % 60;
      const seconds = Math.floor(duration.asSeconds()) % 60;
      return `${hoursRemaining
        .toString()
        .padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    } catch (error) {
      return '--';
    }
  };

  const [fixedValues, setFixedValues] = useState({});

  useEffect(() => {
    const deviceId = positionsInfoBox?.device_id;
    if (!deviceId) {
      setFixedValues({});
      return;
    }
    const newFixedValues = {};
    FIXED_FIELDS.forEach(field => {
      let value;
      if (field === 'sim') {
        value =
          detailedVehicleInfo && detailedVehicleInfo[field] !== undefined
            ? detailedVehicleInfo[field]
            : undefined;
      } else {
        value =
          positionsInfoBox && positionsInfoBox[field] !== undefined
            ? positionsInfoBox[field]
            : detailedVehicleInfo && detailedVehicleInfo[field] !== undefined
            ? detailedVehicleInfo[field]
            : undefined;
      }
      if (value !== undefined) {
        newFixedValues[field] = value;
      }
    });
    setFixedValues(newFixedValues);
  }, [positionsInfoBox?.device_id, detailedVehicleInfo]);

  const renderValueInWindowBox = infor => {
    const safeDetailedVehicleInfo = detailedVehicleInfo || {};
    const safePositionsInfoBox = positionsInfoBox || {};

    const valueSource = FIXED_FIELDS.includes(infor.dataKey)
      ? { [infor.dataKey]: fixedValues[infor.dataKey] }
      : safeDetailedVehicleInfo[infor.dataKey] !== undefined
      ? safeDetailedVehicleInfo
      : safePositionsInfoBox;

    if (
      !FIXED_FIELDS.includes(infor.dataKey) &&
      !BASIC_FIELDS.includes(infor.dataKey) &&
      isInitialLoading
    ) {
      return <Skeleton variant="text" width={40} />;
    }
    if (
      !BASIC_FIELDS.includes(infor.dataKey) &&
      !CALCULATED_FIELDS.includes(infor.dataKey) &&
      safeDetailedVehicleInfo[infor.dataKey] === undefined &&
      !isLoadingDetail
    ) {
      return '--';
    }

    switch (infor.dataKey) {
      case 'created_at':
        return safePositionsInfoBox[infor.dataKey]
          ? moment(safePositionsInfoBox[infor.dataKey] * 1000).format(
              'HH:mm:ss DD/MM/YYYY'
            )
          : '--';
      case 'active_at':
        return valueSource[infor.dataKey]
          ? moment(valueSource[infor.dataKey]).format('DD/MM/YYYY')
          : '--';
      case 'speed_gps':
        return safePositionsInfoBox[infor.dataKey] != null
          ? `${Math.floor(safePositionsInfoBox[infor.dataKey])} Km/h`
          : '--';
      case 'engine_status':
        return valueSource[infor.dataKey] != null
          ? valueSource[infor.dataKey]
            ? 'Bật'
            : 'Tắt'
          : '--';
      case 'max_speed':
        return valueSource[infor.dataKey] != null
          ? `${Math.floor(valueSource[infor.dataKey])} Km/h`
          : '--';
      case 'daily_distance':
        return valueSource[infor.dataKey] != null
          ? `${valueSource[infor.dataKey]} Km`
          : '--';
      case 'total_distance':
        return valueSource[infor.dataKey] != null
          ? `${valueSource[infor.dataKey]} Km`
          : '--';
      case 'air_condition_status':
        return valueSource[infor.dataKey] != null
          ? valueSource[infor.dataKey]
            ? 'Bật'
            : 'Tắt'
          : '--';
      case 'memory_card':
        return valueSource[infor.dataKey] ? 'Bình thường' : '--';
      case 'is_stopping':
        return valueSource[infor.dataKey] ? 'Đang đỗ' : '--';
      case 'remaining_days':
        const dateDebt =
          safeDetailedVehicleInfo.date_debt !== undefined
            ? safeDetailedVehicleInfo.date_debt
            : safePositionsInfoBox.date_debt;
        return getRemainingDays(dateDebt);
      case 'battery':
        return valueSource[infor.dataKey] != null
          ? `${valueSource[infor.dataKey]} V`
          : '--';
      case 'location':
        return (
          <LocationDisplay address={`${valueSource[infor.dataKey] || ''}`} />
        );
      case 'serial':
        return valueSource[infor.dataKey] || '--';
      case 'sim':
        return valueSource[infor.dataKey] || '--';
      case 'gsm_level':
        return (
          <Level4GlAndsatellitesDisplay
            level_4g={`${valueSource[infor.dataKey]}`}
            gsm_signal={valueSource.gsm_signal}
          />
        );
      default:
        return valueSource[infor.dataKey] ?? '--';
    }
  };

  return (
    <Box
      style={{
        width: '100%',
        height: 'auto'
      }}
    >
      <div style={{ flexGrow: 1, paddingTop: '6px' }}>
        <TabPanel
          value={value}
          index={0}
          style={{ minHeight: '160px', overflowY: 'auto' }}
        >
          <List
            component="nav"
            style={{
              padding: '0'
            }}
          >
            {vehicleInfoBox[0]?.map((infor, index) => (
              <React.Fragment key={index}>
                <ListItem
                  disableGutters
                  style={{
                    padding: '4px 10px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div style={{ float: 'left', fontSize: '12px' }}>
                    <img
                      src={`/static/iconSvg/${infor.icon}.svg`}
                      style={{
                        paddingRight: '5px',
                        marginLeft: '0 !important'
                      }}
                    />
                    <b> {infor.label} </b>
                  </div>

                  <div
                    style={{
                      float: 'right',
                      textAlign: 'right',
                      fontSize: '12px'
                    }}
                  >
                    {renderValueInWindowBox(infor)}
                  </div>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
          style={{ minHeight: '160px', overflowY: 'auto' }}
        >
          {vehicleInfoBox[1]?.map((infor, index) => (
            <React.Fragment key={index}>
              <ListItem
                disableGutters
                style={{
                  padding: '4px 10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div style={{ float: 'left', fontSize: '12px' }}>
                  {infor.dataKey === 'gsm_level' ? (
                    <DisplayGsmColumn detailedInfo={detailedVehicleInfo}/>
                  ) : (
                    <img
                      src={`/static/iconSvg/${infor.icon}.svg`}
                      style={{
                        paddingRight: '5px',
                        marginLeft: '0 !important'
                      }}
                    />
                  )}
                  <b> {infor.label} </b>
                </div>

                <div
                  style={{
                    float: 'right',
                    textAlign: 'right',
                    fontSize: '12px'
                  }}
                >
                  {renderValueInWindowBox(infor)}
                </div>
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </TabPanel>
        <TabPanel
          value={value}
          index={2}
          style={{ height: '190px', overflowY: 'auto' }}
        >
          {vehicleInfoBox[2]?.map((infor, index) => (
            <React.Fragment key={index}>
              <ListItem
                disableGutters
                style={{
                  padding: '4px 10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div style={{ float: 'left', fontSize: '12px' }}>
                  <img
                    src={`/static/iconSvg/${infor.icon}.svg`}
                    style={{
                      paddingRight: '5px',
                      marginLeft: '0 !important'
                    }}
                  />
                  <b> {infor.label} </b>
                </div>

                <div
                  style={{
                    float: 'right',
                    textAlign: 'right',
                    fontSize: '12px'
                  }}
                >
                  {renderValueInWindowBox(infor)}
                </div>
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
        </TabPanel>

        <AppBar
          position="static"
          style={{
            backgroundColor: '#ffffff',
            boxShadow: 'none',
            borderRadius: '15px'
          }}
        >
          <Tabs
            value={value}
            variant="fullWidth"
            onChange={handleChange}
            centered
            aria-label="simple tabs example"
            style={{
              height: '35px',
              minHeight: '35px',
              width: '100%',
              borderRadius: '0px 0px 15px 15px'
            }}
            TabIndicatorProps={{ hidden: true }}
          >
            <CustomTab
              label="Phương tiện"
              {...a11yProps(0)}
              style={{
                textTransform: 'none',
                height: '100%',
                minHeight: '35px',
                minWidth: '80px'
              }}
            />
            <CustomTab
              label="Thiết bị"
              {...a11yProps(1)}
              style={{
                textTransform: 'none',
                height: '100%',
                minHeight: '35px',
                minWidth: '80px'
              }}
            />
            {!isMotorGPS && (
              <CustomTab
                label="Lái xe"
                {...a11yProps(2)}
                style={{
                  textTransform: 'none',
                  height: '100%',
                  minHeight: '35px',
                  minWidth: '80px'
                }}
              />
            )}
          </Tabs>
        </AppBar>
      </div>
    </Box>
  );
};

export default React.memo(ContentCarInfo);
